/** Astra always ticks at this rate — leaves main-thread room for the sidebar. */
export const NEURAL_FPS = 30;
export const NEURAL_FRAME_MS = 1000 / NEURAL_FPS;
